import type { TokenizedWord, TrieNode } from "./types";
import { findLongestMatch } from "./trie";

export function isChinese(char: string): boolean {
  const code = char.charCodeAt(0);
  // CJK Unified Ideographs and extensions
  return (
    (code >= 0x4e00 && code <= 0x9fff) || // CJK Unified Ideographs
    (code >= 0x3400 && code <= 0x4dbf) || // CJK Extension A
    (code >= 0x20000 && code <= 0x2a6df) || // CJK Extension B
    (code >= 0x2a700 && code <= 0x2b73f) || // CJK Extension C
    (code >= 0x2b740 && code <= 0x2b81f) || // CJK Extension D
    (code >= 0x2b820 && code <= 0x2ceaf) || // CJK Extension E
    (code >= 0xf900 && code <= 0xfaff) || // CJK Compatibility Ideographs
    (code >= 0x2f800 && code <= 0x2fa1f) // CJK Compatibility Supplement
  );
}

export function tokenize(input: string, trie: TrieNode): TokenizedWord[] {
  const result: TokenizedWord[] = [];
  let i = 0;

  while (i < input.length) {
    const char = input[i];

    // Skip non-Chinese characters (whitespace, punctuation, etc.)
    if (!isChinese(char)) {
      i++;
      continue;
    }

    // Find longest match starting at position i
    const match = findLongestMatch(input, i, trie);

    if (match) {
      // Found a match in dictionary
      result.push({
        text: input.slice(i, i + match.length),
        entries: match.entries,
        startIndex: i,
        endIndex: i + match.length,
      });
      i += match.length;
    } else {
      // No match - single character (unknown word)
      result.push({
        text: char,
        entries: [],
        startIndex: i,
        endIndex: i + 1,
      });
      i++;
    }
  }

  return result;
}
